<p-treeTable #treeTable *ngIf="initialized && ladderTreeNodes" [scrollable]="true" scrollHeight="85vh" [value]="ladderTreeNodes"
    [(selection)]="selectedNode" selectionMode="single" (onNodeSelect)="onNodeSelect($event)" [globalFilterFields]="['breakDown']"
    (onFilter)="primeNGFilterFix($event)" (onNodeExpand)="onNodeExpand($event)" (onNodeCollapse)="onNodeCollapse($event)">
    <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
            <col [style.width]="groupingColHeaderWidth">
            <ng-template ngFor let-item [ngForOf]="ladderColumnNames" let-i="index">
                <col>
            </ng-template>
        </colgroup>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th> </th>
            <ng-template ngFor let-item [ngForOf]="ladderColumnNames" let-i="index">
                <th class="center">{{item}}</th>
            </ng-template>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
        <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode" [ngClass]="'level-' + rowData.level">
            <td>
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>

                {{rowData.breakDown}}
            </td>
            <ng-template ngFor let-item [ngForOf]="ladderColumnNames" let-i="index">
                <td *ngIf="showDelta"
                    [ngClass]="rowData.deltas[i] === 0 ? 'zero-value' : rowData.deltas[i] >= 0 ? 'positive-value' : 'negative-value'">
                    {{rowData.deltas[i] | largeamount}}</td>
                <td *ngIf="!showDelta" [style.padding]="'0.2em'"
                    [ngClass]="rowData.amounts[i] === 0 ? 'zero-value' :  rowData.amounts[i] >= 0 ? 'positive-value' : 'negative-value'">
                    {{rowData.amounts[i] | largeamount}}</td>
            </ng-template>
        </tr>
    </ng-template>
</p-treeTable>